"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("./http.service");
var Subject_1 = require("rxjs/Subject");
var find_http_error_1 = require("../error/find-http-error");
var accessory_amount_1 = require("../model/accessory-amount");
var update_http_error_1 = require("../error/update-http-error");
var movement_1 = require("../model/movement");
var save_http_error_1 = require("../error/save-http-error");
var AccessoryAmountService = /** @class */ (function () {
    function AccessoryAmountService(_httpService) {
        this._httpService = _httpService;
        this.FIND_ACCESSORIES_BY_LOCAL = AccessoryAmountService.ACCESSORY_AMOUNT_ENDPOINT + "/groupByAccessory";
        this.MOVE = AccessoryAmountService.ACCESSORY_AMOUNT_ENDPOINT + "/move";
        this.saveSubject = new Subject_1.Subject();
        this.save$ = this.saveSubject.asObservable();
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.moveSubject = new Subject_1.Subject();
        this.move$ = this.moveSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    AccessoryAmountService.prototype.save = function (accessoryAmount) {
        var _this = this;
        this._httpService.post(AccessoryAmountService.ACCESSORY_AMOUNT_ENDPOINT, accessoryAmount, accessory_amount_1.AccessoryAmount, save_http_error_1.SaveHttpError)
            .subscribe(function (tech) { return _this.saveSubject.next(tech); }, function (error) { return _this.errorSubject.next(error); });
    };
    AccessoryAmountService.prototype.move = function (movement) {
        var _this = this;
        this._httpService.put(this.MOVE, movement, movement_1.Movement, update_http_error_1.UpdateHttpError)
            .subscribe(function () { return _this.moveSubject.next(); }, function (error) { return _this.errorSubject.next(error); });
    };
    AccessoryAmountService.prototype.findAccessoryAmount = function (local) {
        var _this = this;
        this._httpService.get(this.FIND_ACCESSORIES_BY_LOCAL + "?localId=" + local.id + "&localType=" + local.accessoryLocalType, Map, find_http_error_1.FindHttpError)
            .subscribe(function (accessoryAmount) { return _this.findSubject.next(accessoryAmount); }, function (error) { return _this.errorSubject.next(error); });
    };
    AccessoryAmountService.ctorParameters = function () { return [{ type: http_service_1.HttpService }]; };
    AccessoryAmountService.ACCESSORY_AMOUNT_ENDPOINT = '/accessoryAmount';
    return AccessoryAmountService;
}());
exports.AccessoryAmountService = AccessoryAmountService;
//# sourceMappingURL=accessory-amount.service.js.map


// WEBPACK FOOTER //
// accessory-amount.service.js